export const idleDragPreviewOpacity = 0//.3
